import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withStyleSheet } from 'hoc/styles';
import { EventGroupCard } from 'components/EventGroupCard';
import { Stream } from 'components/Stream';
import { styleSheet } from './stylesheet';

const COMPONENT_MAP = {
    event_group: EventGroupCard
};

class EventGroupStream extends PureComponent {
    static propTypes = {
        dashboardId: PropTypes.string.isRequired,
        EmptyComponent: PropTypes.objectOf(PropTypes.any),
        loadMoreMatches: PropTypes.func,
        loading: PropTypes.bool,
        matches: PropTypes.arrayOf(PropTypes.object),
        passedStyles: PropTypes.objectOf(PropTypes.any),
        streamDisplayMode: PropTypes.string.isRequired,
        streamId: PropTypes.string,
        streamProps: PropTypes.objectOf(PropTypes.any).isRequired,
        styles: PropTypes.objectOf(PropTypes.any).isRequired,
        subtitle: PropTypes.string
    };

    static defaultProps = {
        EmptyComponent: undefined,
        loading: false,
        loadMoreMatches: null,
        matches: [],
        passedStyles: {},
        streamId: null,
        subtitle: undefined
    };

    render() {
        const {
            dashboardId,
            EmptyComponent,
            loadMoreMatches,
            loading,
            matches,
            passedStyles,
            streamDisplayMode,
            streamId,
            streamProps,
            styles,
            subtitle
        } = this.props;
        return (
            <Stream
                {...streamProps}
                EmptyComponent={EmptyComponent}
                dashboardId={dashboardId}
                loadMoreMatches={loadMoreMatches}
                loading={loading}
                offset={matches.length}
                streamId={streamId}
                styles={{ ...styles.container, ...passedStyles }}
                subtitle={subtitle}
                headerDisabled
            >
                {matches.map(m => {
                    const CardComponent = COMPONENT_MAP[m.type];
                    return <CardComponent displayMode={streamDisplayMode} key={`event-group-card-${m.id}`} {...m} />;
                })}
            </Stream>
        );
    }
}

export const EventGroupStreamUI = compose(withStyleSheet(styleSheet))(EventGroupStream);
